import type { OwaDate } from '../../../schema';
import { RokuyouDay } from '../../../intl/RokuyouDay';
import {
    GlobalCalendarLocale,
    GlobalCalendarLanguage,
    GlobalCalendarType,
} from '../../../intl/globalCalendarLocale';
import getIntlMonth from '../getIntlMonth';
import getIntlDate from '../getIntlDate';

// The Rokuyou calendar is based on the Chinese lunar calendar.  The language here
// is unimportant since we're only interested in numeric values.  The key is that
// it can't be a language that adds special characters to day numbers which makes
// converting to integers problematic, hence why we are using English and not
// Japanese.
const rokuyouLocale: GlobalCalendarLocale = new GlobalCalendarLocale(
    GlobalCalendarType.ChineseLunar,
    GlobalCalendarLanguage.English
);

const rokuyouDays: RokuyouDay[] = [
    RokuyouDay.Senshou,
    RokuyouDay.Tomobiki,
    RokuyouDay.Sakimake,
    RokuyouDay.Butsumetsu,
    RokuyouDay.Taian,
    RokuyouDay.Shakku,
];

// The Rokuyou calendar consists of a set of 6 days which cycle thru
// as the month progresses.  In the first month, the first day is
// Senshou, the next Tomobiki, all the way up to the sixth day,
// Shakku.  The 7th day starts over at Senshou.  In the second month,
// the first day starts at Tomobiki and goes from there.  The third month,
// Sakimake and so on.  The happens for the first 6 months, and on month 7,
// the cycle starts over again with the first day being Senshou.  The can be
// expressed as the month plus the day - adjusted for zero-origin indexing -
// modulus 6 and then referencing the list of days.
export default function getRokuyouDay(date: OwaDate): RokuyouDay {
    const month: number = Number(getIntlMonth(date, rokuyouLocale, 'numeric')) - 1;
    const dayOfMonth: number = Number(getIntlDate(date, rokuyouLocale, 'numeric')) - 1;

    const dayIndex = (month + dayOfMonth) % 6;

    return rokuyouDays[dayIndex];
}
